export const images = {
  contact: require("../assets/images/viber (2).png"),
  email: require("../assets/images/email.png"),
  logo: require("../assets/images/anax-logo.png"),
  bannerImage: require("../assets/images/banner-image.png"),
  aboutUsImage: require("../assets/images/about-us-section.png"),
  aboutUs: require("../assets/images/aboutUs.png"),
  dots: require("../assets/images/dots.png"),
  rectangle: require("../assets/images/square-image.png"),
  round: require("../assets/images/round.png"),
  spirrel: require("../assets/images/sprirrel.png"),
  homeBanner: require("../assets/images/Home-main-img.png"),
  leftSpirrel: require("../assets/images/left-spirrel.png"),
  rightSpirrel: require("../assets/images/right-spirrel.png"),
  whoImage: require("../assets/images/anax-who-image.png"),
  tickIcon: require("../assets/images/tick-icon.png"),
  whyChooseUs: require("../assets/images/why-choose-us.png"),
  cultureImage: require("../assets/images/cultureImage.png"),
  qualityImage: require("../assets/images/qualityImage.png"),
  innovativeImage: require("../assets/images/innovativeImage.png"),
  visionImage: require("../assets/images/vision.png"),
  missionImage: require("../assets/images/mission.png"),
  valuesImage: require("../assets/images/values.png"),
  medicineImage: require("../assets/images/medicine.png"),
  contactImage: require("../assets/images/contact.png"),
  calender: require("../assets/images/calendar.png"),
  labImage: require("../assets/images/lab-image.png"),
  plusImage: require("../assets/images/plus-image.png"),
  eventImage: require("../assets/images/event.png"),
  businessImage: require("../assets/images/business.png"),
  conferenceImage: require("../assets/images/conference.png"),
  awards: require("../assets/images/awards.png"),
  cricket: require("../assets/images/cricketTournament.png"),
  birthday: require("../assets/images/birthday.png"),
  image1: require("../assets/images/icon.png"),
  footer: require("../assets/images/Footer.png"),
  Anax: require("../assets/images/anax-about.png"),
  Rectangle: require("../assets/images/Rectangle.png"),
  Diahop: require("../assets/images/Diahop.png"),
  Gynec: require("../assets/images/Gynec.png"),
  Ortho: require("../assets/images/Ortho.png"),
  Pedia: require("../assets/images/Pedia.png"),
  Neuro: require("../assets/images/Neuro.png"),
  limevita: require("../assets/images/limevita-logo.png"),
  viznax: require("../assets/images/viznax-logo.png"),
  vildahop: require("../assets/images/vildahop-logo.png"),
  limevitak: require("../assets/images/lime-vita-k-logo.png"),
  medicine: require("../assets/images/holytel.png.png"),
  tube: require("../assets/images/Rectangle.png"),
  slider: require("../assets/images/slider.png"),
  pdfImg:require("../assets/images/pdf.png")
};
